<script>
import create from '../utils/create'
import Pivottable from './Pivottable'
export default create({
  name: 'plottable',
  mixins: [Pivottable]
})
</script>
